import * as React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import useTranslation from '../Language/useTranslation';

interface CountryInfoDialogProps {
    setShowInfo: (show: boolean) => void;
    countryCode: string;
}

const CountryInfoDialog: React.FC<CountryInfoDialogProps> = ({ setShowInfo, countryCode }) => {
    const [open, setOpen] = React.useState(true);
    const t = useTranslation(); // Access translations using the hook

    const handleClose = () => {
        setOpen(false);
        setShowInfo(false);
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="trend-info-dialog-title"
            aria-describedby="trend-info-dialog-description"
        >
            <DialogTitle id="trend-info-dialog-title">
                {t.rightMainDrawer.countryInfoTitle + ": " + countryCode}
            </DialogTitle>
            <DialogContent dividers>
                <Typography variant="h6" gutterBottom>
                    {t.rightMainDrawer.countryInfo}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} autoFocus>
                    Okay
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CountryInfoDialog;
